'use strict';

(function () {
  'use strict';

  angular.module('msPublicActivities').provider('publicActivityRouter', publicActivityRouterProvider);
  /* @ngInject */
  function publicActivityRouterProvider() {
    var provider = this;
    provider.augmentRoutes = _augmentRoutes;
    provider.$get = [publicActivityRouterFactory];

    function publicActivityRouterFactory() {
      //noop
    }

    function _augmentRoutes(activityRoutes) {
      for (var index in activityRoutes) {
        if (activityRoutes.hasOwnProperty(index)) {
          var route = activityRoutes[index];
          if (route.hasOwnProperty('name')) {
            _augmentRoute(route);
          }
        }
      }
      return activityRoutes;
    }

    function _augmentRoute(route) {
      // mix in the public auth flags
      route.data = angular.extend({}, route.data, {
        noAuth: true
      });
      //replace the activity base route with simpler one
      if (route.name === 'public.content.activity') {
        //drop the default /activity/ uri segment from activity routes
        route.url = route.url.replace(/activity\//gi, '');
      }
      //replace the activity.intro html template
      if (route.name === 'public.content.activity.intro') {
        route.templateUrl = 'publicActivities/pages/activity/public-activity-intro.html';
      }
      //replace the base activity html template
      if (route.name === 'public.content.activity') {
        route.template = '<div class="animation-wrapper"><ui-view></ui-view></div>';
      }
      //replace the base activity html template
      if (route.name === 'public.content.activity.feedback') {
        route.templateUrl = 'publicActivities/pages/activity/public-activity-complete.html';
        route.controller = 'PublicActivityCompleteCtrl';
      }
    }
  }
})();